document.addEventListener('DOMContentLoaded', function () {
  
  const headerRow = document.querySelector("header-component .header__row");
  if (!headerRow) return;

  if (window.scrollY > 50) {
    headerRow.classList.add("make-header-white");
  } else {
    headerRow.classList.remove("make-header-white");
  }

  function toggleHeaderClass() {
    if (window.scrollY > 50) {
      headerRow.classList.add("make-header-white");
    } else {
      headerRow.classList.remove("make-header-white");
    }
  }

  // toggleHeaderClass();
  // window.addEventListener("load", toggleHeaderClass);
  window.addEventListener("scroll", toggleHeaderClass);


  // const headerRow = document.querySelector("header-component .header__row");
  // if (!headerRow) return;

  // function getScrollPercent() {
  //   const scrollTop = window.scrollY || window.pageYOffset;
  //   const docHeight = document.documentElement.scrollHeight - window.innerHeight;

  //   if (docHeight <= 0) return 0; 

  //   return (scrollTop / docHeight) * 100;
  // }

  // function toggleHeaderClass() {
  //   const scrollPercent = getScrollPercent();

  //   if (scrollPercent > 1) {
  //     headerRow.classList.add("make-header-white");
  //   } else {
  //     headerRow.classList.remove("make-header-white");
  //   }
  // }

  // // 🔥 Run multiple times to avoid Shopify/render delay issues
  // function runOnLoadFix() {
  //   toggleHeaderClass();

  //   requestAnimationFrame(() => {
  //     toggleHeaderClass();

  //     setTimeout(toggleHeaderClass, 50);
  //     setTimeout(toggleHeaderClass, 150);
  //   });
  // }

  // // Initial
  // runOnLoadFix();

  // // Scroll + resize
  // window.addEventListener("scroll", toggleHeaderClass);
  // window.addEventListener("resize", toggleHeaderClass);










  if (window.innerWidth > 749) return;

  const slider = document.querySelector('.icons-text-with__slider');
  if (!slider) return;

  const track = slider.querySelector('.group-block-content');
  if (!track) return;

  const slides = [...track.children];
  if (!slides.length) return;


  console.log('Slider:', slider);
  console.log('Track:', track);
  console.log('Slides:', slides);

  /* ---------------- STATE ---------------- */
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let dragging = false;
  let index = 0;
  let step = 0;


  /* ---------------- DOTS ---------------- */
  const dotsWrap = document.createElement('div');
  dotsWrap.className = 'icons-text-slider-dots';

  slides.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = 'icons-text-slider-dot';

    if (i === 0) dot.classList.add('active');

    dot.addEventListener('click', () => {
      index = i;
      goToIndex();
    });

    dotsWrap.appendChild(dot);
  });

  slider.after(dotsWrap);
  const dots = [...dotsWrap.children];


  /* ---------------- HELPERS ---------------- */
  function getX(e) {
    return e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].clientX;
  }

  function calcStep() {
    const rect = slides[0].getBoundingClientRect();
    const styles = getComputedStyle(track);

    const gap =
      parseFloat(styles.columnGap) ||
      parseFloat(styles.gap) ||
      0;

    step = rect.width + gap;
  }

  function updateDots() {
    dots.forEach(d => d.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  }

  function setPosition(animate=true) {
    track.style.transition = animate ? 'transform .35s ease' : 'none';
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function goToIndex() {
    // currentTranslate = step - (index * step);
    currentTranslate = -(index * step);
    prevTranslate = currentTranslate;
    setPosition();
    updateDots();
  }


  /* ---------------- INIT ---------------- */
  function initSlider() {

    calcStep();

    // FIX: force left-aligned layout baseline
    track.style.justifyContent = 'flex-start';

    index = 0;

    // START POSITIVE OFFSET
    // currentTranslate = step;
    // prevTranslate = currentTranslate;

    currentTranslate = 0;
    prevTranslate = 0;

    setPosition(false);
    updateDots();
  }


  /* ---------------- DRAG ---------------- */
  function start(e) {
    dragging = true;
    startX = getX(e);
    track.style.transition = 'none';
  }

  function move(e) {
    if (!dragging) return;

    const diff = getX(e) - startX;
    currentTranslate = prevTranslate + diff;

    track.style.transform = `translateX(${currentTranslate}px)`;
  }

    function end() {
        if (!dragging) return;
        dragging = false;

        const moved = currentTranslate - prevTranslate;

        /* ++++++++++++++++ updated : circular slide logic ++++++++++++++++ */
        if (moved < -step / 4) {
            index++;

            // last → first
            if (index >= slides.length) {
            index = 0;
            }
        }
        else if (moved > step / 4) {
            index--;

            // first → last
            if (index < 0) {
            index = slides.length - 1;
            }
        }
        /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

        goToIndex();
    }



  /* ---------------- EVENTS ---------------- */
  track.addEventListener('touchstart', start, { passive:true });
  track.addEventListener('touchmove', move, { passive:true });
  track.addEventListener('touchend', end);

  track.addEventListener('mousedown', start);
  window.addEventListener('mousemove', move);
  window.addEventListener('mouseup', end);

  window.addEventListener('resize', () => {
    if (window.innerWidth > 749) return;
    initSlider();
  });


  /* ---------------- BOOT ---------------- */
  initSlider();





});



document.addEventListener('DOMContentLoaded', function (){ 
  /*  ------------- scroll and zoom effect -------------- */

  // const imageZoomWrapper = document.querySelector(".itg_product-image-text.has-scroll-and-zoom-effect");
  // if (!imageZoomWrapper) return;

  // const imageZoomImg = imageZoomWrapper.querySelector(".itg_product-image-text.section .image-block.scroll-and-zoom-effect img");
  // if (!imageZoomImg) return;

  // const observer = new IntersectionObserver(
  //   (entries, observerInstance) => {
  //     entries.forEach(entry => {
  //       if (entry.intersectionRatio >= 0.5) {
  //         imageZoomImg.classList.add("is-visible");
  //         observerInstance.unobserve(entry.target);
  //       }
  //     });
  //   },
  //   {
  //     threshold: 0.5
  //   }
  // );

  // observer.observe(imageZoomWrapper);


  const imageZoomWrapper = document.querySelector(".itg_product-image-text.has-scroll-and-zoom-effect");
  if (!imageZoomWrapper) return;

  const imageZoomImg = imageZoomWrapper.querySelector(".itg_product-image-text.section .image-block.scroll-and-zoom-effect img");
  if (!imageZoomImg) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.5) {
          imageZoomImg.style.scale = "1";
        } else {
          imageZoomImg.style.scale = "1.2";
        }
      });
    },
    {
      threshold: [0, 0.5]
    }
  );

  observer.observe(imageZoomWrapper);
  /*  ------------- scroll and zoom effect -------------- */

})
  
//   // ------------------------------  slider js ------------------------------

//   if (window.innerWidth > 749) return;

//   const slider = document.querySelector('.icons-text-with__slider');
//   if (!slider) return;

//   const track = slider.querySelector('.group-block-content');
//   if (!track) return;

//   const slides = track.querySelectorAll('.icon-text__slides.group-block');
//   if (!slides.length) return;

//   const OFFSET_INDEX = 1; 

//   let index = 0;
//   let startX = 0;
//   let isDragging = false;
//   let prevTranslate = 0;
//   let currentTranslate = 0;

//   function slideWidth() {
//     return slider.getBoundingClientRect().width;
//   }

//   /* ---------- Dots ---------- */
//   const dotsWrap = document.createElement('div');
//   dotsWrap.className = 'icons-text-slider-dots';

//   slides.forEach((_, i) => {
//     const dot = document.createElement('span');
//     dot.className = 'icons-text-slider-dot';
//     if (i === 0) dot.classList.add('active');

//     dot.addEventListener('click', () => {
//       index = i;
//       updatePosition();
//     });

//     dotsWrap.appendChild(dot);
//   });

//   slider.after(dotsWrap);
//   const dots = dotsWrap.children;

//   /* ---------- Position Logic ---------- */
//   function updatePosition(animate = true) {
//     currentTranslate = (OFFSET_INDEX - index) * slideWidth();
//     prevTranslate = currentTranslate;

//     track.style.transition = animate ? 'transform 0.3s ease' : 'none';
//     track.style.transform = `translateX(${currentTranslate}px)`;

//     [...dots].forEach(d => d.classList.remove('active'));
//     dots[index].classList.add('active');
//   }

//   /* ✅ INITIAL STATE → translateX(+365.6px) */
//   updatePosition(false);

//   /* ---------- Drag ---------- */
//   function getX(e) {
//     return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
//   }

//   function dragStart(e) {
//     if (window.innerWidth > 749) return;
//     isDragging = true;
//     startX = getX(e);
//     slider.classList.add('grabbing');
//     track.style.transition = 'none';
//   }

//   function dragMove(e) {
//     if (!isDragging) return;
//     const diff = getX(e) - startX;
//     currentTranslate = prevTranslate + diff;
//     track.style.transform = `translateX(${currentTranslate}px)`;
//   }

//   function dragEnd() {
//     if (!isDragging) return;
//     isDragging = false;
//     slider.classList.remove('grabbing');

//     const movedBy = currentTranslate - prevTranslate;

//     if (movedBy < -80) {
//       index = (index + 1) % slides.length;
//     } else if (movedBy > 80) {
//       index = (index - 1 + slides.length) % slides.length;
//     }

//     updatePosition();
//   }

//   /* ---------- Events ---------- */
//   track.addEventListener('mousedown', dragStart);
//   track.addEventListener('mousemove', dragMove);
//   track.addEventListener('mouseup', dragEnd);
//   track.addEventListener('mouseleave', dragEnd);

//   track.addEventListener('touchstart', dragStart, { passive: true });
//   track.addEventListener('touchmove', dragMove, { passive: true });
//   track.addEventListener('touchend', dragEnd);

//   window.addEventListener('resize', () => updatePosition(false));

//   // ------------------------------  slider js ------------------------------
  
// });